export const postalCodeMask = "a0a 0a0";
